(function () {
  'use strict';

  angular.module('dcApp').component('projectContexts', {
    bindings: {
      contexts: '<',
      onReady: '&',
    },
    controller: [ProjectContextsController],
    controllerAs: 'vm',
    templateUrl: 'directives/project/project-contexts/project-contexts.html',
  });

  // --- Controller Function ---
  function ProjectContextsController() {
    var vm = this;

    vm.$onInit = onInit;
    vm.getSelectedContexts = getSelectedContexts;

    function onInit() {
      vm.onReady({
        api: {
          getSelectedContexts: getSelectedContexts,
        },
      });
    }

    /**
     * Formatage des contextes sélectionnés pour la sauvegarde du projet.
     */
    function getSelectedContexts() {
      var selected = [];
      for (let c in vm.contexts) {
        if (vm.contexts[c].persistence || vm.contexts[c].jobs) {
          selected.push({
            context_id: vm.contexts[c].id,
            persistence: vm.contexts[c].persistence,
            jobs: vm.contexts[c].jobs,
          });
        }
      }
      return selected;
    }
  }
})();
